import { CSSProperties, forwardRef } from 'react';

import { DropdownNavItem, NavItem } from 'coreOld/components';
import { INavItem } from 'coreOld/types';
import { hasPermission } from 'router/utils';

import { DropdownContainer, DropdownList, DropdownMenu } from './dropdownStyle';

interface IProps {
  isOpen: boolean;
  toggleDropdown: (name: string) => void;
  navItems?: INavItem[];
  name?: string;
  icon?: JSX.Element;
  secondaryNav?: boolean;
  style?: CSSProperties;
  userResources?: string[];
}

const DropdownNavView = forwardRef<HTMLElement, IProps>(function DropdownNavView(
  { isOpen, toggleDropdown, navItems, name, icon, secondaryNav, style, userResources }: IProps,
  ref
) {
  return (
    <DropdownContainer onClick={toggleDropdown} ref={ref}>
      <NavItem
        url="#"
        text={name}
        icon={icon}
        isDropdown
        isDropdownOpen={isOpen}
        secondaryNav={secondaryNav}
        style={style}
        isTextHidden
      />
      <DropdownMenu isOpen={isOpen}>
        <DropdownList>
          {navItems?.map((item, index) => {
            const displayPermission = hasPermission(item?.permissions, userResources);

            if (item?.hide || item?.display === false || !displayPermission) {
              return null;
            }

            return (
              <DropdownNavItem
                key={`${index}-${item?.name}`}
                url={item?.url}
                onClick={item?.onClick}
                text={item.name}
                matchedPath={item?.matchedPath}
                icon={item?.icon}
                hiddenOnSmall={item?.hiddenOnSmall}
                secondaryNav={secondaryNav}
              />
            );
          })}
        </DropdownList>
      </DropdownMenu>
    </DropdownContainer>
  );
});

export default DropdownNavView;
